// components/FormField.jsx
import React, { useState } from 'react';

const FormField = ({
  type = 'text', // Input type: text, textarea, range, checkbox, select, etc.
  label, // Label for the field
  value, // Current value of the field
  onChange, // Function to handle changes
  min, // For range inputs
  max, // For range inputs
  step, // For range inputs
  options, // For select inputs (array of { label, value })
  className = '', // Additional class names
  onLabelClick, // Optional: Click handler for the label
  disabledOptions = [], // Array of values to disable
  ...props // Other props (e.g., placeholder, disabled, etc.)
}) => {
  const fontSizes = {"label": "text-[0.8em]", "field": "text-[0.8em]"}
  const [ labelClickZone, setLabelClickZone ] = useState(onLabelClick ? true : false)
  // Render the appropriate input based on the type
  const renderInput = () => {
    switch (type) {
      case 'textarea':
        return (
          <textarea
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            className={`flex-grow px-3 py-0.5 bg-gray-800 rounded-md border border-gray-600 focus:border-blue-500 outline-none ${fontSizes.field} ${className}`}
            {...props}
          />
        );

      case 'range':
        return (
          <div className="flex flex-grow items-center space-x-2">
            <input
              type="range"
              min={min}
              max={max}
              step={step}
              value={value || 0}
              onChange={(e) => onChange(e.target.value)}
              className={`h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer ${fontSizes.field} ${className}`}
              {...props}
            />
            <span className="w-8 text-right text-sm font-mono">
              {value || 0}
              {props.unit || ''}
            </span>
          </div>
        );

      case 'checkbox':
        return (
          <input
            type="checkbox"
            checked={value || false}
            onChange={(e) => onChange(e.target.checked)}
            className={`h-3 w-3 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer ${fontSizes.field} ${className}`}
            {...props}
          />
        );

      case 'select':
        return (
          <select
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            className={`overflow-hidden flex-grow px-1 py-0.5 bg-gray-800 rounded-md border border-gray-600 focus:border-blue-500 outline-none ${fontSizes.field} ${className}`}
            {...props}
            title={value || ''}
          >
            {options.map((option) => (
              <option
                key={option.value}
                value={option.value}
                disabled={disabledOptions.includes(option.value)} // Disable if value is in disabledOptions
              >
                {option.label}
              </option>
            ))}
          </select>
        );


      default:
        return (
          <input
            type={type}
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            className={`flex-grow px-3 py-0.5 bg-gray-800 rounded-md border border-gray-600 focus:border-blue-500 outline-none ${fontSizes.field} ${className}`}
            {...props}
          />
        );
    }
  };


  return (
    <div className="px-2 flex items-center justify-between mb-2">
      {label && (
        <span
          className={`min-w-24 font-medium ${onLabelClick ? "cursor-pointer" : ""} ${fontSizes.label}`} // Conditionally add cursor-pointer
          onClick={onLabelClick} // Add onClick handler to the label
        >
          {label}
        </span>
      )}
      <div className="flex flex-grow items-center justify-between">
        {renderInput()}
      </div>
    </div>
  );
};

export default FormField;